import Recipes from "./Recipes";

export default Recipes;
